<template>
  <div>
    <h2 class="text-h3 mb-3">Source Articles</h2>
    <NewsTab
      :market="NEW_TECHNOLOGY.slug"
      :categories-articles="NEW_TECHNOLOGY_CATEGORIES"
    />
  </div>
</template>

<script lang="ts" setup>
import NewsTab from '~/components/market-insights/NewsTab.vue'
import {
  NEW_TECHNOLOGY,
  SILICON_ANODE,
  SODIUM_ION_BATTERIES,
  SOLID_STATE,
} from '~/constants/services/constants'
import type { TMarketSlug } from '~/src/types/markets'

const NEW_TECHNOLOGY_CATEGORIES: TMarketSlug[] = [
  SILICON_ANODE.slug,
  SODIUM_ION_BATTERIES.slug,
  SOLID_STATE.slug,
  NEW_TECHNOLOGY.slug,
]
definePageMeta({ isTab: true, layout: 'services' })

defineProps<{
  slug: string
  categoriesArticles?: string[]
}>()
</script>
